// 客戶專屬打包的設定，由 scripts/profile.js 透過 VUE_APP_* 環境變數帶入；
// 線上包沒有這些變數，全部走預設值（全部模組、顯示聯繫 ESGoal 入口、無 AD 登入、有驗證碼）。
const toBool = (value, fallback) => (value === undefined ? fallback : value === 'true');
const includeModules = (process.env.VUE_APP_INCLUDE_MODULES || '').split(',').filter(Boolean);

export default {
  includeModules,
  homePath: process.env.VUE_APP_HOME_PATH || '',
  // 清單為空（線上包）代表全部模組都包含
  isModuleEnabled: key => !includeModules.length || key === 'core' || includeModules.includes(key),
  // 聯繫 ESGoal 的入口（說明、SOS、法規諮詢、角色權限的 SOS 項目）；地端客戶包關掉
  esgoalContact: toBool(process.env.VUE_APP_ESGOAL_CONTACT, true),
  signin: {
    captcha: toBool(process.env.VUE_APP_SIGNIN_CAPTCHA, true),
    ad: {
      enabled: toBool(process.env.VUE_APP_SIGNIN_AD, false),
    },
  },
};
